
import { useEffect } from "react";

export default function ShopRedirect() {
  useEffect(() => {
    window.location.replace("https://shop.takamorirobot.com/");
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
        <div className="max-w-md text-center">
            <h1 className="text-2xl font-semibold">Redirecting to Takamori Shop...</h1>
            <p className="mt-3 text-sm text-gray-700">
            If you’re not redirected automatically,{" "}
            <a className="underline" href="https://shop.takamorirobot.com/">
                click here
            </a>
            .
            </p>
        </div>
    </div>
  );
}
